import request from "../../../../helpers/request"
import { IGetConfigPtMonMedidor } from "./types"

export const getConfigPtMonMedidor = async ({ adrModulo, idCentral, idEntrada }: IGetConfigPtMonMedidor) => {
    const url = `${process.env.REACT_APP_API}/MonMedidor/GetByEntrada?idCentral=${idCentral}&adrModulo=${adrModulo}&idEntrada=${idEntrada}`
  const result = await request({ url })
  return result.data
}